import React from 'react'
import { Flex } from '@chakra-ui/core'
import { NoFocusButton } from './NoFocusButton'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import LocaleText from 'components/LocaleText'

export type TabKey = 'groups' | 'users' | 'tags' | string
const defaultTabs: { key: TabKey; label: string }[] = [
  { key: 'groups', label: 'groups' },
  { key: 'users', label: 'users' },
  { key: 'tags', label: 'tags' },
]

interface Props {
  value: TabKey
  onChange: (val: TabKey) => void
  tabs?: { key: TabKey; label: string }[]
}

export const NavButtonTabs: React.FC<Props> = ({ value, onChange, tabs }) => {
  const theme = useSelector((state: RootState) => state.general.theme)
  const renderedTabs: { key: TabKey; label: string }[] = tabs || defaultTabs

  return (
    <Flex borderRadius="5px" bg="white" w="100%" justifyContent="space-around" boxShadow="0px 0px 0px 1px #e0e0e0">
      {renderedTabs.map((tab) => (
        <NoFocusButton
          key={tab.key}
          variant="ghost"
          size="sm"
          w={`${100 / renderedTabs.length}%`}
          minW="100px"
          px="20px"
          py="8px"
          borderRadius="3px"
          bg={value === tab.key ? theme?.elementsColor : 'transparent'}
          color={value === tab.key ? 'white' : 'gray.500'}
          border={value === tab.key ? `1px solid ${theme?.elementsColor}` : 'none'}
          fontWeight={value === tab.key ? 'bold' : 'normal'}
          _hover={{
            bg: value === tab.key ? theme?.elementsColor : 'transparent',
            color: value === tab.key ? 'white' : 'gray.500',
          }}
          onClick={() => onChange(tab.key)}
        >
          <LocaleText text={tab.label} />
        </NoFocusButton>
      ))}
    </Flex>
  )
}
